module.exports = __webpack_public_path__ + "static/media/scale-vertical.076c5b08.svg";